export default (message: any) =>
  message.senderType === 'system' || message.sender_type === 'system';
